import { useCallback } from "react";
import {
  deployPlanFormSlice,
  selectBackupPlanMessagedIds,
  selectBackupPlanMessages,
  selectPlanFormBackupMessage,
  selectPlanFormPeriodMessage,
  selectPeriodMessagedIds,
  selectPeriodMessages,
} from "src/store/slices/deployPlanFormSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { useMessageType } from "./useMessageType";
import { Period } from "./periodIndex";
import { PlanId } from "components/common/boundary/PlanId";

export const useMessageFormActions = (formPlanId: PlanId) => {
  const messageType = useMessageType();
  const dispatch = useAppDispatch();

  const messagedPeriods = useAppSelector((state) =>
    selectPeriodMessagedIds(state, formPlanId)
  );

  const messagedBackupPlanIds = useAppSelector((state) =>
    selectBackupPlanMessagedIds(state, formPlanId)
  );

  const setPeriodMessage = useCallback(
    (planId: PlanId, message: string, period: Period) => {
      dispatch(
        deployPlanFormSlice.actions.setPeriodMessage([planId, message, period])
      );
    },
    [dispatch]
  );

  const setBackupMessage = useCallback(
    (formPlanId: PlanId, message: string, backupPlanId: PlanId) => {
      dispatch(
        deployPlanFormSlice.actions.setSMSBackupMessage([
          formPlanId,
          message,
          backupPlanId,
        ])
      );
    },
    [dispatch]
  );

  return {
    messagedPeriods,
    messagedBackupPlanIds,
    periodMessageSelector: selectPlanFormPeriodMessage,
    backupMessageSelector: selectPlanFormBackupMessage,
    periodMessagesSelector: selectPeriodMessages,
    backupMessagesSelector: selectBackupPlanMessages,
    setPeriodMessage,
    setBackupMessage,
    messageType,
  };
};
